import { IconSizeTokens, } from '@voltmoney/schema';
export const args = {
    isChecked: false,
    size: IconSizeTokens.MD,
};
export const argTypes = {
    size: {
        control: 'select',
        options: [...Object.values(IconSizeTokens)],
    },
    onPress: (isChecked) => {
        console.warn('isChecked->', isChecked);
    },
};
